export const RETRY_PAYMENT_FLOW_STEP_ONE: any = {
  flow_slug: 'retryPaymentFlow',
  flow_version: 1,
  uuid: 'retry_payment_flow_step_one',
  subtext: '',
  layout: '',
  settings: {
    submit_label: 'Retry payment',
    align: 'center'
  },
  heading: 'Retry overdue payment',
  sections: [
    {
      uuid: 'payment_outstanding_info',
      subtext: '',
      layout: '',
      settings: {
        card: false,
        hero: ''
      },
      heading: '',
      elements: [
        {
          uuid: 'payment_outstanding_info',
          subtext: '',
          layout: 'review',
          info: {
            type: 'string',
            heading: '',
            content: '',
            settings: {
              align: 'top',
              show_info: true
            }
          },
          settings: {
            read_only: true
          },
          prompt: '',
          key: 'payment_details_review',
          type: 'string',
          required: false
        }
      ]
    },
    {
      uuid: 'policy_details_section',
      subtext: '',
      layout: '',
      settings: {
        card: true,
        hero: ''
      },
      heading: 'Your policy',
      elements: [
        {
          uuid: 'policy_details_review',
          subtext: '',
          layout: 'review',
          info: {
            type: 'string',
            heading: '',
            content: '',
            settings: {
              align: 'top',
              show_info: true
            }
          },
          settings: {
            read_only: true
          },
          prompt: '',
          key: 'policy_details_review',
          type: 'string',
          required: false
        },
      ]
    },
    {
      uuid: 'payment_review_section',
      subtext: '',
      layout: '',
      settings: {
        card: true,
        hero: ''
      },
      heading: 'Current payment details',
      elements: [
        {
          uuid: 'payment_details_review',
          subtext: '',
          layout: 'review',
          info: {
            type: 'string',
            heading: '',
            content: '',
            settings: {
              align: 'top',
              show_info: true
            }
          },
          settings: {
            read_only: true
          },
          prompt: '',
          key: 'payment_details_review',
          type: 'string',
          required: false
        }
      ]
    }
  ],
  interstitial: {
    type: 'default',
    settings: {
      icon: '/assets/svgs/common/loading-blue.svg',
      time: 6000
    },
    heading: 'Retrying your payment'
  },
  data: {
    _flow_metadata: {
      current_page_uuid: 'retry_payment_flow_step_one'
    }
  },
  human: {},
  progress: 1,
  total_pages: 2,
  actions: {
    back: {},
    next: {}
  },
  analytics: {
    flow_slug: 'retryPaymentFlow',
    flow_version: 1,
    page_uuid: 'retry_payment_flow_step_one',
    policy_slug: '',
    user_slug: '',
    payment_type: ''
  }
};

export const RETRY_PAYMENT_FLOW_STEP_TWO: any = {
  flow_slug: 'retryPaymentFlow',
  flow_version: 1,
  uuid: 'retry_payment_flow_step_two',
  subtext: '',
  layout: '',
  settings: {
    submit_label: 'Return to dashboard',
    align: 'center',
    tracking: [
      {
        action: 'invoice.settled',
        options: {
          is_agent: false
        },
        type: 'survicate'
      }
    ]
  },
  heading: 'Your payment has been received successfully',
  sections: [
    {
      uuid: 'policy_details_success_section',
      subtext: '',
      layout: '',
      settings: {
        card: true,
        hero: ''
      },
      heading: 'Your policy',
      elements: [
        {
          uuid: 'policy_details_success_review',
          subtext: '',
          layout: 'review',
          info: {
            type: 'string',
            heading: '',
            content: '',
            settings: {
              align: 'top',
              show_info: true
            }
          },
          settings: {
            read_only: true
          },
          prompt: '',
          key: 'policy_details_review',
          type: 'string',
          required: false
        },
      ]
    },
    {
      uuid: 'payment_review_success_section',
      subtext: '',
      layout: '',
      settings: {
        card: true,
        hero: ''
      },
      heading: 'Payment details',
      elements: [
        {
          uuid: 'payment_details_success_review',
          subtext: '',
          layout: 'review',
          info: {
            type: 'string',
            heading: '',
            content: '',
            settings: {
              align: 'top',
              show_info: true
            }
          },
          settings: {
            read_only: true
          },
          prompt: '',
          key: 'payment_details_review',
          type: 'string',
          required: false
        },
      ]
    },
  ],
  data: {
    _flow_metadata: {
      current_page_uuid: 'retry_payment_flow_step_two'
    }
  },
  human: {},
  progress: 2,
  total_pages: 2,
  actions: {
    next: {}
  },
  analytics: {
    flow_slug: 'retryPaymentFlow',
    flow_version: 1,
    page_uuid: 'retry_payment_flow_step_two',
    policy_slug: '',
    user_slug: '',
    payment_type: ''
  }
};
